import { inject, Injectable } from '@angular/core';
import { Objekt } from './objekt';
import { ScanObjektRepository } from './scan-objekt.repository';
import { Scan } from '@softline/application';
import { ObjektRepository } from './objekt.repository';

@Injectable({providedIn: 'root'})
export class ScanObjektService {

  private readonly scanRepository = inject(ScanObjektRepository);
  private readonly objectRepository = inject(ObjektRepository);

  async load(scan: Scan): Promise<Objekt | null> {
    const scanResult = await this.scanRepository.load({scan});
    if (!scanResult.result)
      return null;
    return (await this.objectRepository.load({ id: scanResult.result.id }))?.result ?? null;
  }

}
